export class IPAssignemntDto {
    primaryAddress: string;
    secondaryAddresses: Array<string>;
    subnetMask: string;
    subnetPrefixLength: number;
    constructor() {
        this.secondaryAddresses = [];
    }
}

export class EdgeInterfaceDto {
    index: number;
    name: string;
    type: string;
    networkId: string;
    networkName: string;
    isConnected: boolean;
    addressGroups: Array<IPAssignemntDto>;
    tunnelId: number;
    parentInterfaceIndex: number;
    isNew: boolean = false;
}

export class EdgeSubInterfaceDto {
    name: string;
    networkId: string;
    networkName: string;
    isConnected: boolean;
    addressGroups: Array<IPAssignemntDto>;
    tunnelId: number;
    parentInterfaceIndex: number
}

export class GatewayCliSettingsDto {
    remoteAccess: boolean;
    userName: string;
    password: string;
    sshLoginBannerText: string;
    passwordExpiry: string;
}

export class HighAvailabilityDto{
    enabled: boolean;
}

export class RoutingConfigDto {
    staticRouting: StaticRouteDto;
}

export class StaticRouteDto {
    defaultRoute: DefaultRouteDto;
}

export class DefaultRouteDto {
    vnic: string;
    mtu: number;
    description: number;
    adminDistance: number;
    gatewayAddress: string;

    constructor() {
        this.vnic = '0';
        this.adminDistance = 1;
        this.mtu = 1500;
    }
}

export default class GatewayDto {
    organization?: string;
    scopeId?: string;
    managedBy?: boolean;
    vimId?: string;
    edgeId?: string;
    interfaces: Array<EdgeInterfaceDto>;
    cliSettings?: GatewayCliSettingsDto;
    edgeVmSize: string;
    deploymentContainerType: string;
    deploymentContainerId?: string;
    objectId?: string;
    name: string;
    description?: string;
    // default gateway settings
    ipAddress: string;
    mtu: string;
    defaultInterface: string;
    routingConfig: RoutingConfigDto;
    id?: string;
    haSettings: HighAvailabilityDto;
    state: string;

    constructor() {
        this.cliSettings = new GatewayCliSettingsDto();
        this.haSettings = new HighAvailabilityDto();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dto/gateway-dto.ts